import { getPostHog } from 'src/services/analytics';

// DEV OVERRIDE: dev builds have no PostHog (initAnalytics returns early when
// REACT_APP_PRODUCTION !== 'TRUE'), so force treatment locally to QA the
// feature against the dev backend (which runs DAILY_BOOST_FORCE_TREATMENT).
// Ignored in production builds.
const DEV_FORCE_VARIANT = 'treatment';

const FLAG_KEY = 'daily-boost-streak';
// localStorage (NOT sessionStorage) so the assignment survives identify()'s
// reloadFeatureFlags(), auth redirects, and new tabs — same bucketing-stability
// reasoning as onboardingVariant.js.
const CACHE_KEY = 'pupvote_daily_boost_variant';

function readCache() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached === 'control' || cached === 'treatment') return cached;
  } catch (e) { /* localStorage unavailable */ }
  return null;
}

/**
 * Resolve the Daily Boost experiment variant: 'control' | 'treatment'.
 * Pins the first resolved assignment so the user stays in one arm for the
 * experiment's life. Falls back to 'control' whenever the flag is
 * unresolved or PostHog is absent — control users must never see the
 * feature, treatment users at worst see it one page-load late.
 */
export function getDailyBoostVariant() {
  if (process.env.REACT_APP_PRODUCTION !== 'TRUE' && DEV_FORCE_VARIANT) {
    return DEV_FORCE_VARIANT;
  }

  const cached = readCache();
  if (cached) return cached;

  const ph = getPostHog();
  if (!ph) return 'control';

  const flag = ph.getFeatureFlag(FLAG_KEY, { send_event: false });
  const variant = flag === 'treatment' ? 'treatment' : 'control';

  // Only persist once PostHog has actually resolved the flag.
  if (flag != null) {
    try { localStorage.setItem(CACHE_KEY, variant); } catch (e) { /* */ }
  }

  return variant;
}

export function isDailyBoostTreatment() {
  return getDailyBoostVariant() === 'treatment';
}

/**
 * Clear the pinned assignment. Call on logout so the next user re-buckets.
 */
export function clearDailyBoostVariantCache() {
  try { localStorage.removeItem(CACHE_KEY); } catch (e) { /* */ }
}
